export class Poi {
  // type = 'Point';
  x: number;
  y: number;
}
